/**
 * Recuperar senha.
 *
 * A tela mostra **sempre a mesma confirmação**, tenha o e-mail conta ou não.
 * O servidor já responde igual nos dois casos; se a tela diferenciasse — um
 * "e-mail não encontrado", um tempo de espera diferente — devolveria a
 * enumeração que o servidor evitou.
 */
import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { requestPasswordReset } from '../../auth/api';
import { Card } from '../../ui/primitives';
import { Field } from './Field';

export function SenhaScreen() {
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  async function pedir(evento: FormEvent) {
    evento.preventDefault();
    setEnviando(true);
    setErro(null);

    try {
      await requestPasswordReset(email.trim(), `${window.location.origin}/senha/nova`);
      setEnviado(true);
    } catch (e) {
      // Só falha de transporte chega aqui — o servidor responde 200 para
      // e-mail existente e inexistente.
      setErro(e instanceof Error ? e.message : 'Não foi possível enviar agora.');
    } finally {
      setEnviando(false);
    }
  }

  if (enviado) {
    return (
      <section className="auth-screen">
        <h1 className="auth-title">Confira seu e-mail</h1>
        <p className="auth-subtitle">
          Se {email.trim()} estiver cadastrado, o link de redefinição chegou lá.
        </p>
        <Card variant="chip">
          <p className="auth-note">
            Não avisamos se um e-mail está ou não cadastrado — é o que impede
            alguém usar esta tela para descobrir quem participa das viagens.
          </p>
        </Card>
        <Link className="auth-link" to="/entrar">
          Voltar para entrar
        </Link>
      </section>
    );
  }

  return (
    <section className="auth-screen">
      <h1 className="auth-title">Recuperar senha</h1>
      <p className="auth-subtitle">
        Informe o e-mail da sua conta. Enviamos um link para você criar uma
        senha nova.
      </p>

      <form className="auth-form" onSubmit={pedir}>
        <Field
          label="E-mail"
          type="email"
          autoComplete="email"
          inputMode="email"
          placeholder="voce@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        {erro && (
          <p className="auth-error" role="alert">
            {erro}
          </p>
        )}
        <button
          type="submit"
          className="nv-btn nv-btn--primary nv-btn--block"
          disabled={enviando || email.trim().length === 0}
        >
          {enviando ? 'Enviando…' : 'Enviar link'}
        </button>
      </form>

      <Card variant="chip">
        <p className="auth-note">
          Se o e-mail não estiver cadastrado, não avisamos.
        </p>
      </Card>
    </section>
  );
}
